import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaExclamationTriangle,
  FaHome,
  FaShieldAlt,
} from "react-icons/fa";

import backgroundImage from "./HeaderSlider_02.jpg";

function ErrorPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);

  const error =
    params.get("error") ||
    location.state?.error ||
    location.state?.message ||
    "La page demandée est introuvable ou une erreur est survenue.";

  const status =
    params.get("status") ||
    location.state?.status ||
    "404";

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate("/");
  };

  return (
    <main className="relative flex min-h-screen items-center justify-center overflow-hidden bg-slate-950 px-4 py-28 text-white sm:px-6 lg:px-8">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-25"
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      />

      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(242,113,49,0.30),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(59,130,246,0.22),transparent_32%)]" />
      <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.08)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.08)_1px,transparent_1px)] bg-[size:44px_44px] opacity-20" />
      <div className="absolute inset-0 bg-slate-950/55" />

      <section className="relative w-full max-w-3xl">
        <div className="overflow-hidden rounded-[2.5rem] border border-white/10 bg-white/10 p-6 shadow-2xl backdrop-blur-2xl sm:p-8 lg:p-10">
          <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-[1.7rem] bg-white text-3xl text-primary shadow-xl">
            <FaExclamationTriangle />
          </div>

          <div className="mt-8 text-center">
            <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-4 py-2 text-xs font-bold uppercase tracking-[0.22em] text-white/70">
              <FaShieldAlt className="text-primary" />
              Erreur {status}
            </div>

            <h1 className="mt-6 font-barlow text-4xl font-bold leading-tight tracking-tight text-white sm:text-5xl lg:text-6xl">
              Oups, une erreur est survenue
            </h1>

            <p className="mx-auto mt-5 max-w-2xl text-base leading-8 text-white/75">
              {error}
            </p>
          </div>

          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <button
              type="button"
              onClick={handleGoBack}
              className="inline-flex w-full items-center justify-center gap-3 rounded-full border border-white/20 bg-white/10 px-6 py-3.5 text-sm font-bold text-white shadow-lg backdrop-blur-xl transition hover:-translate-y-0.5 hover:bg-white/15 sm:w-auto"
            >
              <FaArrowLeft />
              Revenir en arrière
            </button>

            <Link
              to="/"
              className="inline-flex w-full items-center justify-center gap-3 rounded-full bg-primary px-6 py-3.5 text-sm font-bold text-white shadow-[0_18px_45px_rgba(242,113,49,0.32)] transition hover:-translate-y-0.5 hover:brightness-110 sm:w-auto"
            >
              <FaHome />
              Retour à l’accueil
            </Link>
          </div>
        </div>

        <p className="mt-6 text-center text-xs font-medium text-white/45">
          Vous pouvez revenir à la page précédente ou retourner à l’accueil du
          site.
        </p>
      </section>
    </main>
  );
}

export default ErrorPage;